import React, { memo } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import IntlMessages from '../../../helpers/IntlMessages';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Input, Label, Form, FormGroup } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import DynamicForm from '../general/DynamicForm';

const ContentComponent = ({
    title,
    isOpen,
    toggle,
    onSubmit,
    values,
    onChange,
}) => {
    // const filterPassedTime = (time) => {
    //     const currentDate = new Date();
    //     const selectedDate = new Date(time);

    //     return currentDate.getTime() < selectedDate.getTime();
    // };
    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            wrapClassName='modal-right'
            backdrop={true}
            autoFocus={false}
        >
            <Form onSubmit={(e) => onSubmit(e)}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody className='scrool modal-right-add'>
                    <PerfectScrollbar
                        options={{
                            suppressScrollX: true,
                            wheelPropagation: false,
                        }}
                        id='modal-right__body'
                    >
                        <FormGroup>
                            <Label for='title' className='text-muted'>
                                <IntlMessages id='todo.title' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                autoFocus={true}
                                type='text'
                                name='title'
                                id='title'
                                value={values.title}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label for='description' className='text-muted'>
                                <IntlMessages id='todo.description' /><span style={{color: 'red'}}>*</span>
                            </Label>
                            <Input
                                type='textarea'
                                name='description'
                                id='description'
                                value={values.description}
                                onChange={onChange}
                            />
                        </FormGroup>
                        <Label
                            for='momentFormatSelectDateTime'
                            className='text-muted'
                        >
                            <IntlMessages id='todo.date-time' /><span style={{color: 'red'}}>*</span>
                        </Label>
                        <DatePicker
                            name='momentFormatSelectDateTime'
                            id='momentFormatSelectDateTime'
                            className='mb-3'
                            onChange={onChange}
                            selected={moment(
                                values.momentFormatSelectDateTime,
                                'YYYY-MM-DD HH:mm'
                            )}
                            showTimeSelect
                            timeFormat='HH:mm'
                            timeIntervals={15}
                            dateFormat='YYYY-MM-DD / HH:mm'
                            timeCaption='Giờ'
                            // filterTime={filterPassedTime}
                        />
                        {/* 
                        <DynamicForm
                            values={values.dynamic_form}
                            data={data_dynamic_form}
                            onChange={onChangeDynamicForm}
                            disabled={setting.viewonly && !setting.add}
                        /> */}
                    </PerfectScrollbar>
                </ModalBody>
                <ModalFooter>
                    <Button color='primary'>
                        <IntlMessages id='general.btn-add' />
                    </Button>{' '}
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default memo(ContentComponent);
